// extracted by mini-css-extract-plugin
export var inlineLink = "_az-0";
export var inlineLinkButton = "_az-1";